import React, { FC, memo } from "react";

import { ImageContainerWrapper, ImageContainerBg, ImageContainerText, ImageContainerTitle } from "./styled";
import { ContainerProps } from "../types";

export const ImageContainer: FC<ContainerProps> = memo(({ elementConfig, renderElement }) => {
  const { style } = elementConfig || {};

  return (
    <ImageContainerWrapper style={style}>
      <ImageContainerTitle>{renderElement({ id: "alias" })}</ImageContainerTitle>
      <ImageContainerText>{renderElement({ id: "text" })}</ImageContainerText>
      {renderElement({ id: "button" })}
      <ImageContainerBg>{renderElement({ id: "image" })}</ImageContainerBg>
    </ImageContainerWrapper>
  );
});
